import type { ModuleType, ProjectState } from "Infrastructure/Api/Api";
import { useAppNavigate } from "Infrastructure/Routing/useAppNavigate";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";
import { MODULE_TYPE_CONFIG } from "Modules/Utils/moduleTypeConfig";
import {
  type BlDetailSectionItem,
  DetailSection,
} from "Shared/Sections/DetailSection";
import { StatusChip } from "Shared/StatusChip";

interface ProjectListItem {
  projectID: string;
  name: string;
  state: ProjectState;
  moduleType: ModuleType;
}

interface ProjectListSectionProps {
  title: string;
  emptyMessage: string;
  projects: ProjectListItem[];
}

export const ProjectListSection = ({
  title,
  emptyMessage,
  projects,
}: ProjectListSectionProps): React.ReactNode => {
  const navigate = useAppNavigate();

  const items: BlDetailSectionItem[] = projects.map((project) => {
    const config = MODULE_TYPE_CONFIG[project.moduleType];
    return {
      id: project.projectID,
      startAdornment: config ? (
        <DetailSection.IconAdornment color={config.color}>
          {config.icon}
        </DetailSection.IconAdornment>
      ) : undefined,
      label: {
        text: project.name,
        onClick: () =>
          navigate(AppRouting.ProjectDetail.path(project.projectID)),
      },
      endAdornment: <StatusChip projectState={project.state} />,
    };
  });

  return (
    <DetailSection title={title} items={items} emptyMessage={emptyMessage} />
  );
};
